import script from "./AdminVehicleEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminVehicleEditorView.vue?vue&type=script&setup=true&lang=js"

import "./AdminVehicleEditorView.vue?vue&type=style&index=0&id=3c89de8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c89de8c"]])

export default __exports__